import { render, staticRenderFns } from "./NewDisplay.vue?vue&type=template&id=1db8e2a8&lang=html&"
import script from "./NewDisplay.vue?vue&type=script&lang=js&"
export * from "./NewDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports